import type { TRuleWithTheme } from '@/styles/theme';

export const targetIcon: TRuleWithTheme = ({ theme }) => ({
    display: 'inline-flex',
    flexShrink: 0,
    color: theme.colors.iconsPrimary,
});

export const name: TRuleWithTheme = ({ theme }) => ({
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: '0.0125rem',
    fontWeight: 400,
    color: theme.colors.foregroundsPrimary,
});

// Mirrors the `name` span's flex slot so the chevron keeps its position while
// the skeleton is shown; keeps the row at the loaded state's 24px height.
export const nameSkeleton: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    height: '1.5rem',
});

// antd sizes `.ant-skeleton-node` via `.ant-skeleton.ant-skeleton-element .ant-skeleton-node`,
// so the override has to match that ancestor chain to outweigh the default dimensions.
export const nameSkeletonNode: TRuleWithTheme = () => ({
    '&.ant-skeleton.ant-skeleton-element .ant-skeleton-node': {
        width: '6rem',
        height: '1rem',
    },
});

export const chevron: TRuleWithTheme<{ open: boolean }> = ({ open, theme }) => ({
    flexShrink: 0,
    color: theme.colors.iconsPrimary,
    transition: 'transform 0.15s ease',
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
});
